import React from "react";
import styled from "styled-components";
import { useStaticQuery, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

import Container, { Half, Row, Third, TwoThird } from "../layout/container"

const Section = styled.section`
    padding-bottom: 5rem;
    @media screen and (max-width: ${(props) => props.theme.breakpoints.phone}) {
        padding-bottom: 0;
    }
    ul {
        font-family: ${(props) => props.theme.fontCondensed};
    }
    h3 {
      font-family: ${(props) => props.theme.fontTurmoil};
      border-bottom: 3px solid ${props => props.theme.colors.primary};
      padding-bottom: 1.5rem;
    }
`;

const ContainerRowChange = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

const HalfPageChange = styled.div`
  width: 48%;: 100%;
  }
`

const Background = styled(StaticImage)`
  // width: 100%;
  // height: 300px;
  transition: all 0.15s ease-in-out;
  &:hover {
    transform: scale(1.015);
  }
`;

const GridItem = styled.div`
  overflow: hidden;
  position: relative;
  h4 {
    font-family: ${(props) => props.theme.fontGreen};
    letter-spacing: 0.05rem;
    color: ${(props) => props.theme.colors.white};
    font-size 3rem;
    @media screen and (max-width: ${(props) => props.theme.breakpoints.phone}) {
        font-size 2rem;
    }
    margin: 0;
  }
  span {
    font-size 1rem;
    color: ${(props) => props.theme.colors.white};
    border-bottom: 1px solid ${(props) => props.theme.colors.white};
    @media screen and (max-width: ${(props) => props.theme.breakpoints.phone}) {
        font-size 0.8rem;
    }
  }
  @supports (grid-column-gap: 1rem) {
    width: 100%;
    flex: 0;
    margin: 0;
    justify-content: none;
    @media screen and (max-width: ${(props) => props.theme.breakpoints.phone}) {
      flex: 0;
    }
  }
  flex: 1 0 34%;
  margin: 0 0rem 2rem 2rem;
  justify-content: space-between;
  @media screen and (max-width: ${(props) => props.theme.breakpoints.phone}) {
    flex: 1 0 50%;
  }

  a {
    text-decoration: none;
  }
  &:hover {
    .cover-image {
      .image {
        //opacity: 0.5;
      }
      .centered {
        //visibility: visible;
        //opacity: 0.5;
        background-color: rgba(238,208,199, 0.5)
      }
    }
  }
  .cover-image {
    position: relative;
    text-align: center;
    .image {
      opacity: 1;
      transition: 0.3s;
    }
    .centered {
        
        //transition: 0.3s;
        position: absolute;
        top: 50%;
        background-color: ${(props) => props.theme.colors.secondary};
        left: 50%;
        width: 100%;
        height: 100%;
        transform: translate(-50%,-50%);
        opacity: 1;
        //transition: visibility 0s,opacity 0.3s linear;
      .center {
        top: 50%;
        transform: translate(-50%,-50%);
        left: 50%;
        position: absolute;
      }
    }
  }
 
  
`;

const PlanVisit = () => {
  
  return (
    <Section>
      <h3>PLAN YOUR VISIT</h3>
        <ContainerRowChange>
            <HalfPageChange>
                <GridItem>
                    <Link to="/visiting/">
                        <div className="cover-image">
                          <StaticImage
                              className="image"
                              src="../../images/Shepherds-Bush-Market-visitor.jpg" 
                              alt=""
                          />
                          <div className="centered">
                              <div className="center">
                                <h4>VISITING</h4>
                                <span>Maps &amp; Travel</span>
                              </div>
                          </div>
                        </div>
                    </Link>
                </GridItem>
            </HalfPageChange>
            <HalfPageChange>
                <GridItem>
                    <Link to="/about/">
                        <div className="cover-image">
                            <StaticImage
                                className="image"
                                src="../../images/Shepherds-Bush-Market.jpg" 
                                alt=""
                            />
                            <div className="centered">
                              <div className="center">
                                <h4>ABOUT</h4>
                                <span>107-Year History</span>
                              </div>
                            </div>
                        </div>
                    </Link>
                </GridItem>
            </HalfPageChange>
        </ContainerRowChange>
    </Section>
  );
};

export default PlanVisit;